export default {
      id: "money-transfer-usage",
      viewBox: "0 0 129 111",
      url: __webpack_public_path__ + "icons-sprite.ef97e87.svg#money-transfer-usage",
      toString: function () {
        return this.url;
      }
    }